import { render, staticRenderFns } from "./ForbiddenStartUsing.vue?vue&type=template&id=169c06de&scoped=true&"
import script from "./ForbiddenStartUsing.vue?vue&type=script&lang=js&"
export * from "./ForbiddenStartUsing.vue?vue&type=script&lang=js&"
import style0 from "./ForbiddenStartUsing.vue?vue&type=style&index=0&id=169c06de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "169c06de",
  null
  
)

export default component.exports